module.exports = __webpack_public_path__ + "static/media/piggyBank.dee8b708.svg";